import {useQuery} from '@tanstack/react-query'

import {getDecisionMatrix} from './api'
import {creditDecisionKeys} from './keys'
import type {CreditDecisionResponse} from './types'

export const useCreditDecisionMatrix = (companyId?: string) => {
  return useQuery<CreditDecisionResponse>({
    queryKey: creditDecisionKeys.detail(companyId || ''),
    queryFn: () => getDecisionMatrix(companyId),
    enabled: !!companyId,
  })
}
